import styles from "./ProfileInfo.module.scss";
import maleIcon from "../../ProfilePage/icons/male.png";
import femaleIcon from "../../ProfilePage/icons/female.png";
import editIcon from "./icons/edit.png";
import { useSelector } from "../../../../hooks";
import { Gender } from "../../../../redux/profile";
import { getAgeRangeDescription } from "../../ProfilePage/ProfilePage";
import { QuizContext } from "../../QuizRoutes";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../../components/Menu/MenuButton";

export const ProfileInfo = () => {
    const { gender, ageRange } = useSelector(store => store.user.profile);
    const navigate = useNavigate();

    const getIcon = () => gender === Gender.Male ? maleIcon : femaleIcon;

    const getGenderText = () => gender === Gender.Male ? "Мужчина" : "Женщина";

    const onEditHandler = () => navigate(`/${AppContext.Quiz}/${QuizContext.Profile}`);

    return (
        <div className={styles.header}>
            <div className={styles.userInfo}>
                <img src={ getIcon() } alt="User" className={styles.userIcon} />
                
                <div className={styles.userDetails}>
                    <div className={styles.gender}>{ getGenderText() }</div>
                    <div className={styles.age}>{ getAgeRangeDescription(ageRange) }</div>
                </div>
            </div>

            <img src={editIcon} alt="Edit" className={styles.editIcon} onClick={ onEditHandler } />
        </div>
    );
}